import PcmSound from './PcmSound';

// Concrete PcmSound subclass that fetches audio from a URL.
// The decoded AudioBuffer is cached by URL via the provided SoundCache.
export default class UrlSound extends PcmSound {
	constructor(soundManager, cache, url) {
		super(soundManager, cache);
		if(!url) throw 'Please specify the URL as a parameter';
		this.cacheKey = url;
	}

	fetchAudioArrayBuffer(signal) {
		const res = fetch(this.cacheKey, { signal });
		return res.then(r => {
			if(!r.ok) throw new Error(`HTTP ${r.status} fetching ${this.cacheKey}`);
			return r.arrayBuffer();
		});
	}
}
